"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RpcRequestBuilder = void 0;
const cq_core_1 = require("@leavy/cq-core");
const axios_1 = require("axios");
const RpcRequest_1 = require("./RpcRequest");
const HttpRpcRequest_1 = require("./HttpRpcRequest");
const qs = require("qs");
/**
 * Create new {@link RpcRequest}
 * The {@link RpcRequestBuilder} will select the proper {@link RpcRequest} implementation based on the invocation object constructor metadata.
 */
class RpcRequestBuilder {
    constructor(configProviders, axiosInstance) {
        this.configProviders = new Map(configProviders.map(c => [c.protocol, c]));
        this.configurationCache = new Map();
        this.axiosHttp = axiosInstance !== null && axiosInstance !== void 0 ? axiosInstance : axios_1.default;
        if (this.axiosHttp.defaults.paramsSerializer) {
        }
        this.axiosHttp.defaults.paramsSerializer = params => qs.stringify(params);
    }
    /**
     * Create new {@link RpcRequest} from invocation object.
     * @param invocation
     * @param protocol
     */
    async from(invocationClass, invocationData, protocol) {
        const invocationSettings = cq_core_1.readInvocationSettings(invocationClass);
        if (!invocationSettings) {
            throw new Error("Could not get invocation protocol. The Invocation protocol decorator might be missing");
        }
        const config = await this.getConfiguration(invocationClass, invocationSettings, protocol);
        switch (protocol) {
            case RpcRequest_1.RequestProtocol.Http:
                return this.createHttpRequest(invocationData, config, invocationSettings);
            default:
                throw Error(`Unsupported protocol ${protocol}`);
        }
    }
    /**
     * Create new {@link HttpRpcRequest} for HTTP requests
     * @param invocation The inocation object
     * @param config Http configurations
     * @param invocationSettings
     */
    createHttpRequest(invocation, config, invocationSettings) {
        return new HttpRpcRequest_1.HttpRpcRequest(invocation, invocationSettings, this.axiosHttp, config.url, config.verb, config.formDataSerializer);
    }
    /**
     * Retrieve a cached protocol configuration
     * @param constructor
     * @param settings
     * @param protocol
     * @private
     */
    async getConfiguration(constructor, settings, protocol) {
        let config = this.configurationCache.get(constructor);
        if (!config) {
            const configProvider = this.configProviders.get(protocol);
            if (!configProvider) {
                throw new Error(`Missing configuration provider for protocol ${protocol}`);
            }
            config = await configProvider.getConfig(settings);
            this.configurationCache.set(constructor, config);
        }
        return config;
    }
}
exports.RpcRequestBuilder = RpcRequestBuilder;
//# sourceMappingURL=RpcRequestBuilder.js.map